import React, { useMemo } from 'react';
import { Modal } from 'antd';

import { isNil } from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
import DataGrid from 'components/DataGrid';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import moment from 'moment';

type TabAssetUseHistoryModalProps = {
  data: any;
  visible: boolean;
  onClose: () => void;
};

const TabAssetUseHistoryModal = (props: TabAssetUseHistoryModalProps) => {
  const { data, visible, onClose } = props;

  const columns = useMemo<DataGridColDef<any>[]>(
    () => [
      {
        dataIndex: 'usevalue',
        width: 150,
        fixed: 'left',
      },
      {
        dataIndex: 'usevaluedate',
        key: 'usevaluedate',
        render: (value, record, index) =>
          !isNil(value) ? moment(value).format('YYYY-MM-DD') : '',
        width: 180,
      },
      {
        dataIndex: 'uselabel',
        key: 'uselabel',
        width: 130,
      },
      {
        dataIndex: 'creationdate',
        render: (value, record, index) =>
          !isNil(value) ? moment(value).format('YYYY-MM-DD') : '',
        width: 140,
      },
      {
        dataIndex: 'flagupdatefv',
        width: 140,
      },
      {
        dataIndex: 'flagupdatemv',
        width: 140,
      },
      {
        dataIndex: 'newmarketvalue',
        width: 140,
      },
    ],
    []
  );

  return (
    (<Modal
      open={visible}
      onCancel={onClose}
      width={800}
      title={<GetLabel label="AssetuseHistory" />}
      footer={null}
    >
      <DataGrid
        columns={columns}
        dataSource={data ?? []}
        pagination={false}
        scroll={{ y: 100 }}
        rowKey="useid"
        size="small"
        hideFilters
        bordered
      />
    </Modal>)
  );
};

export default TabAssetUseHistoryModal;
